import React from "react";


export const HardwireKit = () => {
    return (
      <>
          <div className="product_view hardwire">
              <div className="bgBox" style={{backgroundImage: "url('/assets/images/product/hardwire/banner.jpg')"}}>
                  <section className="section_0">
                      <div className="image-box">
                          <div className="text-box">
                              <p className="text-01">FineVu Dash Cam<br/>
                                  Hardwire Kit
                              </p>
                              <p className="text-02">For Parking Mode</p>
                              <ul style={{margin: '25px 0 22px'}}>
                                  <li>
                                      <img src="/assets/images/product/hardwire/icon_01.png" alt=""/>
                                      <p>Multi<br/>
                                          Protection
                                      </p>
                                  </li>
                                  <li>
                                      <img src="/assets/images/product/hardwire/icon_02.png" alt=""/>
                                      <p>3-wire<br/>
                                          (BAT+/ACC/GND)</p>
                                  </li>
                                  <li>
                                      <img src="/assets/images/product/hardwire/icon_03.png" alt=""/>
                                      <p>Universal Kit</p>
                                  </li>
                                  <li>
                                      <img src="/assets/images/product/hardwire/icon_04.png" alt=""/>
                                      <p>Output-Input<br/>
                                          Voltage<br/>
                                          12V/24V 2A
                                      </p>
                                  </li>
                                  <li>
                                      <img src="/assets/images/product/hardwire/icon_05.png" alt=""/>
                                      <p>Fuse Tap<br/>
                                          Options</p>
                                  </li>
                                  <li>
                                      <img src="/assets/images/product/hardwire/icon_06.png" alt=""/>
                                      <p>Cars and Trucks</p>
                                  </li>
                                  <li style={{marginLeft: '-30px'}}>
                                      <img src="/assets/images/product/hardwire/icon_07.png" alt=""/>
                                      <p>Constsnt<br/>
                                          Power<br/>
                                          24/7 Parking Mode</p>
                                  </li>
                              </ul>
                          </div>

                      </div>
                  </section>
              </div>
              <div className="tabWrap tabBtnWrapBattery">
                  <div className="tabContentBox">
                      <div className={`features active`}>
                          <section className="section_9">
                              <div className="half">
                                  <div className="text-area">
                                      <div>
                                          <p className="text-01">Why Use a Hardwire Kit?</p>
                                          <p className="text-02">Cigarette lighter adapters lose power when your car is off,<br/>
                                              making 24/7 parking protection impossible.<br/>
                                              A hardwire kit connects directly to your vehicle's<br/>
                                              fuse box to provide constant power 24/7, so your<br/>
                                              dash cam can automatically start recording when it<br/>
                                              detects motion or impact while parked-protecting<br/>
                                              your vehicle even when you're away.
                                          </p>
                                      </div>
                                  </div>
                                  <div className="image-area">
                                      <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-01.png" alt=""/>
                                  </div>
                              </div>
                          </section>

                          <section className="section_9">
                              <div className="half">
                                  <div className="text-area">
                                      <div>
                                          <p className="text-01">Enables Dash Cam Parking Mode</p>
                                          <p className="text-02">Connects your FineVu dash cam directly to the vehicle's fuse box,<br/>
                                              allowing the dash cam to operate while driving and switch to<br/>
                                              parking mode after the vehicle is turned off.
                                          </p>
                                      </div>
                                  </div>
                                  <div className="image-area">
                                      <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-02.png" alt=""/>
                                  </div>
                              </div>
                          </section>

                          <section className="section_9">
                              <div className="half">
                                  <div className="text-area">
                                      <div>
                                          <p className="text-01">3-Wire Power Connection</p>
                                          <p className="text-02">Features dedicated RED ACC power, YELLOW constant power,<br/>
                                              and BLACK ground wires for stable dash cam operation<br/>
                                              and proper driving/parking mode switching.
                                          </p>
                                      </div>
                                  </div>
                                  <div className="image-area">
                                      <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-03.png" alt=""/>
                                  </div>
                              </div>
                          </section>

                          <section className="section_9">
                              <div className="half">
                                  <div className="text-area">
                                      <div>
                                          <p className="text-01">Complete Installation Kit Included</p>
                                          <p className="text-02">Comes with a hardwire power cable, fuse puller tool, test light,<br/>
                                              cable clips, trim tool, cable ties, piggy back fuse taps, fuse types,<br/>
                                              and user manual for organized installation.
                                          </p>
                                      </div>
                                  </div>
                                  <div className="image-area">
                                      <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-04.png" alt=""/>
                                  </div>
                              </div>
                          </section>

                          <section className="section_3">
                              <p className="text-01"><img src="/assets/images/product/hardwire/1.png" alt="1"/> Check the components and locate the fuse box for the hardwire connection.</p>
                              <div className="image-box">
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05.png" alt=""/>
                              </div>
                          </section>

                          <section className="section_4">
                              <p className="text-01"><img src="/assets/images/product/hardwire/2.png" alt="2"/> Identify the fuse type used in your vehicle and prepare the piggyback fuse tap.</p>
                              <div className="image-box">
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-01.png" alt=""/>
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-02.png" alt=""/>
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-03.png" alt=""/>
                              </div>
                          </section>

                          <section className="section_5">
                              <p className="text-01"><img src="/assets/images/product/hardwire/3.png" alt="3"/> Connect the hardwire power cable and attach the ground (GND).</p>
                              <div className="image-box">
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-04.png" alt=""/>
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-05.png" alt=""/>
                              </div>
                          </section>

                          <section className="section_4">
                              <p className="text-01"><img src="/assets/images/product/hardwire/4.png" alt="4"/> Secure and route the wiring.</p>
                              <div className="image-box">
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-06.png" alt=""/>
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-07.png" alt=""/>
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-05-08.png" alt=""/>
                              </div>
                          </section>

                          <section className="section_9">
                              <div className="half">
                                  <div className="text-area">
                                      <div>
                                          <p className="text-01">12V–24V Vehicle Compatibility</p>
                                          <p className="text-02">Designed for vehicles with DC 12V–24V power systems.<br/>
                                              Recommended fuse slot rating: 10A–30A.<br/>
                                              Compatible with most cars, trucks, and SUVs.
                                          </p>
                                      </div>
                                  </div>
                                  <div className="image-area">
                                      <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-06.png" alt=""/>
                                  </div>
                              </div>
                          </section>

                          <section className="section_9">
                              <div className="half">
                                  <div className="text-area">
                                      <div>
                                          <p className="text-01">12V–24V Vehicle Compatibility</p>
                                          <p className="text-02">Designed for vehicles with DC 12V–24V power systems.<br/>
                                              Recommended fuse slot rating: 10A–30A.<br/>
                                              Compatible with most cars, trucks, and SUVs.
                                          </p>
                                      </div>
                                  </div>
                                  <div className="image-area">
                                      <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-07.png" alt=""/>
                                  </div>
                              </div>
                          </section>

                          <section className="section_8" style={{marginBottom: '100px'}}>
                              <div className="imgBox">
                                  <img src="/assets/images/product/hardwire/FineVu-Dash-Cam-Hardwire-kit-08.png" alt=""/>
                              </div>
                          </section>
                      </div>
                  </div>
              </div>
          </div>
      </>
    )
}
